import { Component } from "preact";
import { connect } from "react-redux";
import config from "../config";

class Chat extends Component {
  componentDidMount() {
    const { user } = this.props;
    if (config("NODE_ENV") !== "test") {
      const script = document.createElement("script");

      script.src = `//js.hs-scripts.com/4534422.js`;
      script.async = true;
      script.defer = true;
      script.type = "text/javascript";
      script.id = "hs-script-loader";

      document.body.appendChild(script);
    }
  }

  render() {
    return null;
  }
}

export default connect((state, ownProps) => ({}), {})(Chat);
